// Main entry point for the Vite-powered Rails application

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "../channels"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "react-quill/dist/quill.snow.css";

// Import React components for mounting
// Note: Individual page components are loaded per-page, not globally

// Prevent double initialization
if (!window._rails_loaded) {
  Rails.start()
  window._rails_loaded = true
}

if (!window._turbolinks_loaded) {
  Turbolinks.start()
  window._turbolinks_loaded = true
}

if (!window._activestorage_loaded) {
  ActiveStorage.start()
  window._activestorage_loaded = true
}
